import { Component, OnInit, OnDestroy, ViewChild, ElementRef, Input } from '@angular/core';
import { applyFroalaAriaFix, stripFroalaWatermark } from '../../../../common/utils/froala.utils';
import { ActivatedRoute, Router, NavigationExtras } from '@angular/router';
import { BehaviorSubject, Subscription, of, Observable } from 'rxjs';
import { finalize, mergeMap, tap } from 'rxjs/operators';
//import { PDFDocumentProxy } from 'pdfjs-dist';

import { LoaderService } from '../../../../common/services/loader.service';

import { GenerateReportModel } from '../../../../reports/model/reports.model';
import { levelContext } from '../../../../models/comodel/chiefsorderdetailsmodel.model';
import { DynamicDialogService } from '../../../../core/services/dynamic-dialog.service';
import { Dialog, DialogButton } from '../../../../core/models/dialog.model';
import { Group } from '../../../models/group.model';
import { GroupService } from '../../../services/group.service';
import { IReportContextValue, ReportTemplate } from '../../../../models/comodel/mergefieldsmodel.model';
import { TextTemplatesService } from '../../../../text-templates/text-templates.service';
import { lettercontentmodel } from '../../../../models/comodel/lettercontentmodel.model';
import { ReportSelectorService } from '../../../../form-controls/services/report-selector.service';
import { FormControl, FormGroup } from '@angular/forms';
import { LettersService } from '../../../../letters/letters.service';
import { Letter, LetterAddress, PdfMergeConfig } from '../../../../letters/letters.model';
import { IDocument } from '../../../../common/services/document-management.service';
import { AuthService } from '../../../../services/auth.service';
import { mergeFieldsOrgInfo } from '../../../../common/models/organization.model';

@Component({
    selector: 'letter-creation',
    templateUrl: './letter-creation.component.html',
    styleUrls: ['./letter-creation.component.scss'],
    standalone: false
})
export class LetterCreationComponent implements OnInit,OnDestroy {

    submitConfirmationDialog: Dialog = new Dialog("Are you sure you're done editing this letter, and want to send it to the mailer?", [
        new DialogButton("Yes", true, () => this.onSubmitDialogConfirm()),
        new DialogButton("Cancel", false, () => this.onSubmitDialogCancel()),
    ]);

    successDialog: Dialog = new Dialog("This Letter was successfully sent to the mailer.", [new DialogButton("OK", true, () => this.onSubmitSuccessDialogConfirm())]);
    failureDialog: Dialog = new Dialog("This Letter was NOT successfully sent to the mailer.", [new DialogButton("OK", true, () => this.onSubmitfailureDialogConfirm())]);
    selectAReviewGroupReminderDialog: Dialog = new Dialog("Please select a valid review group and try again.", [new DialogButton("OK", true, () => this.onSelectAReviewGroupReminderDialogConfirm())]);

    @Input() reportTemplate: ReportTemplate;
    @Input() orgInfo: mergeFieldsOrgInfo;
    @Input() mergeFields: IReportContextValue[];
    @ViewChild("downloadLink") public downloadLink: ElementRef;
    letterContent: lettercontentmodel;
    updatedLetterHtml: string;
    updatedLetterHeader: string;
    updatedLetterFooter: string;
    togglePreviewText: string = "Generate PDF preview";
    currentPage: number = 1;
    displayEditor: boolean = true;
    pdfAvailable: boolean = false;
    pdfData: any;
    pdfUrl: string;
    title: string;

    private reportModel: GenerateReportModel;
    showError: boolean = false;
    sub = new Subscription();
    submitModel: levelContext;
    totalPages: number = 0;


    displayGroupAssignment: boolean = false;
    allGroups: Group[] = [];
    selectedGroup: Group = {
        id: "0",
        displayName: "---------- Please Select a Group ----------",
        active: true,
        groupType: "placeholder",
        permissions: [],
        users: []
    };

    private _isLoading$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
    get isLoading$(): Observable<boolean> {
        return this._isLoading$.asObservable();
    }

    constructor(
        private activeRoute: ActivatedRoute,
        private readonly loader: LoaderService,
        public textTemplateService: TextTemplatesService,
        public reportService: ReportSelectorService,
        private router: Router,
        public dialogService: DynamicDialogService,
        public groupService: GroupService,
        public letterService: LettersService,
        private authService: AuthService
    ) {
        this.reportModel = new GenerateReportModel();
        this.reportModel.useBanner = true;
        this.reportModel.usePageNumberHeader = true;
        this.reportModel.formatAsLetter = true;
        this.reportModel.htmlHeader = "";
        this.reportModel.html = "";
        this.reportModel.htmlFooter = "";
        this.reportModel.styleMergeFields = true;
    }

    ngOnInit() {
        this.loader.toggleLoader(true);

        
        const templateContent$ = this.textTemplateService.getTemplateContent(this.reportTemplate.id).pipe(
            tap((contents) => {
                this.letterContent = contents;
                this.reportModel.usePageNumberHeader = this.letterContent.usePageNumberHeader;
                this.reportModel.mergeFields = this.mergeFields;
                this.reportModel.html = this.letterContent.htmlContent;
                this.reportModel.htmlHeader = this.letterContent.htmlHeader;
                this.reportModel.htmlFooter = this.letterContent.htmlFooter;
                this.reportModel.replaceContentWithMergeFields();
                this.updatedLetterHtml = this.reportModel.html;
                this.updatedLetterHeader = this.reportModel.htmlHeader;
                this.updatedLetterFooter = this.reportModel.htmlFooter;
               
            }),
            mergeMap(() => {
                //If we need to display groups for selecting next level, fetch them
                if (this.displayGroupAssignment) {
                    return (this.groupService.get({ stubs: false }) as Observable<Group[]>).pipe(
                        tap((groups) => {
                            if (groups) {
                                groups.unshift(this.selectedGroup);
                                this.allGroups = groups;
                            }
                        })
                    );
                } else {
                    return of(null);
                }
            }),
            mergeMap(() => {
                return this.generatePdf();
            }),
            finalize(() => { this.sub.add(templateContent$); })
        ).subscribe((data) => {
            this.pdfAvailable = data !== null;
            this.loader.toggleLoader(false);
            this._isLoading$.next(false);
        }, (error) => {
            console.error(error);
            this.showError = true;
            this.loader.toggleLoader(false);
        });
    }

    ngOnDestroy(): void {
        if (this.sub) this.sub.unsubscribe();        
    }

    download(): void {
        const blob = new Blob([this.pdfData], { type: "application/pdf" });
        const fileName = `letter-preview.pdf`;
		const url = URL.createObjectURL(blob);
		const link = this.downloadLink.nativeElement;
		link.href = url;
		link.download = fileName;
		link.click();
    }

    private _froalaOptions: any = null;
    get froalaOptions(): any {
        if (!this._froalaOptions) {
            let conf = window["PdfConfig"] as any;
            let key = (conf != null) ? conf.editorLicenseKey : "";
            this._froalaOptions = applyFroalaAriaFix({
                heightMax: 500,
                height: 500,
                heightMin: 150,
                key: key,
                fontSize: ['8', '9', '10', '11', '12', '14', '16', '18', '20', '22', '24', '26', '26.5', '27', '30', '60', '72', '96'],
                fontFamily: {
                    'Arial,Helvetica,sans-serif': 'Arial',
                    'Georgia,serif': 'Georgia',
                    'Impact,Charcoal,sans-serif': 'Impact',
                    'Tahoma,Geneva,sans-serif': 'Tahoma',
                    "'Times New Roman',Times,serif": 'Times New Roman',
                    'Verdana,Geneva,sans-serif': 'Verdana',
                    'Gabriola,sans-serif': 'Gabriola',
                },
                toolbarButtons: ["fullscreen", "html", "|", "undo", "redo", "|", "bold", "italic", "underline", 'strikeThrough', "|", "formatOL", "formatUL", "|", "align", "fontFamily", "fontSize", "paragraphFormat", "insertLink", "|", "outdent", "indent", "clearFormatting", "insertTable", "color"]
            });
        }
        return this._froalaOptions;
    }
    form: FormGroup = new FormGroup({
        updatedContents: new FormControl('')
    });

    togglePreview() {
        this.displayEditor = !this.displayEditor;

        if (this.displayEditor)
            this.togglePreviewText = "Generate PDF preview"
        else {
            this.togglePreviewText = "Return to letter editor";

            this.loader.toggleLoader(true);
            var generatePDF$ = this.generatePdf().pipe(finalize(() => { this.sub.add(generatePDF$); })).subscribe(result => {
                this.pdfAvailable = result != null;
                //This should probably do more to deal with what is really an error state where no result comes back.
                this.loader.toggleLoader(false);
                
            }, error => {
                this.loader.toggleLoader(false);
                console.log('failed to save...' + error);
            });
        }
    }

    generatePdf(): Observable<any> {
        this.reportModel.html = this.updatedLetterHtml;
        this.reportModel.htmlHeader = this.updatedLetterHeader;
        this.reportModel.htmlFooter = this.updatedLetterFooter;
        if (this.reportModel.html && this.reportModel.html !== "" && !this.displayEditor) {
            return this.reportService.generate(this.reportModel).pipe(
                tap((blob) => {
                    if (blob) {
                        this.pdfUrl = window.URL.createObjectURL(blob);
                        this.pdfData = blob;
                    }
                })
            );
        } else {
            return of(null);
        }
    }

    nextPage(): void {
        if (this.currentPage >= this.totalPages) return;
        this.currentPage++;
    }

/*onLoadComplete(pdf: PDFDocumentProxy): void {*/
	onLoadComplete(pdf: any): void {
        this.totalPages = pdf.numPages;
    }

    previousPage(): void {
        if (this.currentPage <= 1) return;
        this.currentPage--;
    }

    createLetter() {
        this.submitConfirmationDialog.toggleDialog(true);
        this.dialogService.updateDialog(this.submitConfirmationDialog);
    }


    public onSubmitDialogConfirm(): void {
        let orgIdMergeFields = this.mergeFields.filter(a => a.contextValue == "orgId");
        let orgId = "";
        if (orgIdMergeFields.length > 0)
            orgId = orgIdMergeFields[0].replaceValue;

        let orgNameMergeFields = this.mergeFields.filter(a => a.contextValue == "orgName");
        let orgName = "";
        if (orgNameMergeFields.length > 0)
            orgName = orgNameMergeFields[0].replaceValue;

        let fileName = this.reportTemplate.name + ' ' + orgId + ' ' + new Date().toDateString() + ".pdf";
        let recipient = new LetterAddress();
        recipient.address1 = this.orgInfo.address.street;
        recipient.city = this.orgInfo.address.city;
        recipient.name1 = orgName;
        recipient.state = this.orgInfo.address.stateCode;
        recipient.zipCode = this.orgInfo.address.zipCode;

        let document = {
            documentType: this.reportTemplate.onBaseDocumentTypeName,
            auditUser: this.authService.User.displayName,
            auditDate: new Date(new Date().toUTCString()),
            contentType: "text/html",
            name: fileName
        } as IDocument;

        let pdfMergeConfig = new PdfMergeConfig();
        pdfMergeConfig.htmlFooter = this.reportModel.htmlFooter;
        pdfMergeConfig.htmlHeader = this.reportModel.htmlHeader;
        pdfMergeConfig.prefixPageNumberFooterWithExhibitLetter = true;
        pdfMergeConfig.stampPageNumberFooter = true;
        pdfMergeConfig.prefixPageNumberFooterWithExhibitLetter = true;

        let letter = {
            onBaseDocumentTypeName: this.reportTemplate.onBaseDocumentTypeName,
            onBaseFileName: fileName,
            formatAsLetter: true,
            headerOnFirstPage: true,
            useBanner: true,
            useChiefsOrderHeader: false,
            usePageNumberHeader: true,
            recipient: recipient,
            office: null,
            organizationId: orgId,
            organizationName: orgName,
            title: this.reportTemplate.name + ' letter for ' + orgId,
            documentTypeId: document.documentType,
            isCertified: true,
            pageCount: 0,
            mergeConfig: pdfMergeConfig,
            trackRRE: true,
        } as Letter;

        
        this.loader.toggleLoader(true);
        var generateLetter$ = this.letterService.createLetter(letter, document, stripFroalaWatermark(this.updatedLetterHtml), this.mergeFields, [])
                                                    .pipe(finalize(() => { this.sub.add(generateLetter$); }))
                                                    .subscribe(result => {
                                                                let letter = result;
                                                                this.loader.toggleLoader(false);
                                                                this.successDialog.toggleDialog(true);
                                                                this.dialogService.updateDialog(this.successDialog);
        }, error => {
            this.loader.toggleLoader(false);
            console.log('failed to save...' + error);
            this.failureDialog.message = "An error occurred, and this letter was NOT successfully sent to the mailer.";
            this.failureDialog.toggleDialog(true);
            this.dialogService.updateDialog(this.failureDialog);
        });
    }

    public onSubmitDialogCancel(): void {

    }

    public onSubmitSuccessDialogConfirm(): void {
        this.router.navigate(["/dashboard/view/ricsDashboard"]);
    }

    onSubmitfailureDialogConfirm(): void {        
    }

    onSelectAReviewGroupReminderDialogConfirm() {
        this.selectAReviewGroupReminderDialog.toggleDialog(false);
        this.dialogService.updateDialog(this.selectAReviewGroupReminderDialog);
    }
}
